import React, {useEffect, useState} from 'react';
import PageHeader from './components/PageHeader';
import PageFooter from './components/PageFooter';
import MainContentArea from './components/MainContentArea';
import { useSelector } from 'react-redux';
import { HOME_ROUTE, MODULE_ROUTE } from './routeTypes';
import useQRScanner from '../../library/hooks/deviceIntegration/useQRScannerJavaLoop';
import PageSidebar from './components/PageSidebar';

export default function MasterPage(props) {
    const { children, deviceInfo } = props;
    const [pathClass, setPathClass] = useState("");
    const serverAttributes = useSelector(state => state.auth.server);

    useQRScanner(true);

    const initialisePath = () => {
        if(props.match.path === HOME_ROUTE){
            setPathClass("uiSarasPathHome");
        }
        else if(props.match.path === MODULE_ROUTE){
            setPathClass("uiSarasPathModule");
        }
        else{
            setPathClass("uiSarasDefaultPath");
        }
    };
    
    useEffect(initialisePath, [props.match]);

    return (
        <div className={`${pathClass} uiSarasPackage${serverAttributes.PackageCode} uiSarasClient${serverAttributes.ClientCode} uiMasterLayout ${deviceInfo.isMobile ? 'uiMobileLayout' : ''} ${deviceInfo.orientation === 'portrait' ? 'uiPortrait' : 'uiLandscape'}`}>
            <div className="uiMasterLayoutTopbar">
                <PageHeader currentPath={props.match.path} deviceInfo={deviceInfo}/>
            </div>
            <div className="uiMasterLayoutRow">
                {!deviceInfo.activateMobileView && <div className="uiMasterLayoutSidebar saras-tour-home-side-menu">
                    <PageSidebar />
                </div>}
                <div className="uiMasterLayoutMain uiAppPaper">
                    <div className="uiMainContentWithFooter">
                        <MainContentArea>
                            {children}
                        </MainContentArea>
                    </div>
                    <PageFooter />
                </div>
            </div>
        </div>
    );
}

